// [2026-03-22] 역할에 따라 테넌트 목록을 가져오는 공통 훅
import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../stores/authStore';
import { tenantsAPI, authAPI } from '../services/api';

export function useMyTenants() {
  const user = useAuthStore((s) => s.user);
  const isSuperuser = user?.is_superuser === true;

  const { data, isLoading } = useQuery({
    queryKey: ['my-tenants', isSuperuser],
    queryFn: async () => {
      if (isSuperuser) {
        const res = await tenantsAPI.list(1, 100);
        return res.data.items || [];
      } else {
        const res = await authAPI.myTenants();
        return res.data || [];
      }
    },
  });

  return { tenants: data || [], isLoading };
}
